import clsx from 'clsx';
import { endOfDay } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { toTitleCase } from '../../../../../../_metronic/helpers';
import {
  RemarkOptionLabel,
  RemarkOptionStatus,
  RemarkOptionType,
} from '../../../../../pages/siteIntelligence/mappings';
import MultiSelection from '../../components/MultiSelection';
import SearchInputGroup from '../../components/SearchInputGroup';
import { useFilter } from '../../FilterContext';
import DatePickerFilter from '../components/DatePickerFilter';

export function RemarkOptionFilter() {
  const params = useParams();
  const intl = useIntl();
  const { globalFilter, setGlobalFilter } = useFilter();
  const filterKey = 'remarkOptionList';

  const typeOptions = Object.entries(RemarkOptionType).map(([key, value]) => ({
    value: key,
    label: toTitleCase(value),
  }));

  const autoDetectOptions = Object.entries(RemarkOptionLabel).map(([key, value]) => ({
    value: key,
    label: toTitleCase(value.replace(/_/g, ' ')),
  }));

  const statusOptions = Object.entries(RemarkOptionStatus).map(([key, value]) => ({
    value: key,
    label: toTitleCase(value),
  }));

  return (
    <>
      <div className={clsx(params.id ? 'blur' : '')}>
        <div className='d-inline-flex flex-wrap'>
          {/* Select */}
          <div className='d-inline-flex flex-wrap pb-2'>
            {/* Date Picker */}
            <DatePickerFilter
              onChange={(selectedDate) =>
                setGlobalFilter({
                  ...globalFilter,
                  [filterKey]: {
                    ...globalFilter?.[filterKey],
                    created_at: selectedDate && {
                      from: zonedTimeToUtc(new Date(selectedDate.start), 'Hongkong').toISOString(),
                      to: zonedTimeToUtc(
                        new Date(endOfDay(selectedDate.end)),
                        'Hongkong'
                      ).toISOString(),
                    },
                  },
                })
              }
              globalFilterValue={
                globalFilter?.[filterKey]?.created_at?.from &&
                globalFilter?.[filterKey]?.created_at?.to && {
                  startDate: new Date(globalFilter?.[filterKey]?.created_at?.from),
                  endDate: new Date(globalFilter?.[filterKey]?.created_at?.to),
                }
              }
              label='Created At'
              placeholder='Filter Created At'
              className='me-6'
            />

            {/* Type */}
            <MultiSelection
              title='Type'
              globalFilterValue={globalFilter?.[filterKey]?.type?.values}
              options={typeOptions}
              onChange={(e) => {
                setGlobalFilter({
                  ...globalFilter,
                  [filterKey]: {
                    ...globalFilter?.[filterKey],
                    type: { type: 'in', values: e },
                  },
                });
              }}
            />

            {/* Auto Detect Method */}
            <MultiSelection
              title='Auto Detect Method'
              globalFilterValue={globalFilter?.[filterKey]?.auto_detect_method?.values}
              options={autoDetectOptions}
              onChange={(e) => {
                setGlobalFilter({
                  ...globalFilter,
                  [filterKey]: {
                    ...globalFilter?.[filterKey],
                    auto_detect_method: { type: 'in', values: e },
                  },
                });
              }}
            />

            {/* Status */}
            <MultiSelection
              title='Status'
              globalFilterValue={globalFilter?.[filterKey]?.status?.values}
              options={statusOptions}
              onChange={(e) => {
                setGlobalFilter({
                  ...globalFilter,
                  [filterKey]: {
                    ...globalFilter?.[filterKey],
                    status: { type: 'in', values: e },
                  },
                });
              }}
            />
          </div>
        </div>

        {/* Search */}
        <SearchInputGroup
          inputs={[
            {
              key: 'remark_option_id',
              title: 'ID',
              minWidth: 350,
              maxWidth: 700,
            },
            {
              key: 'translations.label',
              title: 'Remark',
              minWidth: 350,
              maxWidth: 700,
            },
          ]}
          section={filterKey}
          globalFilterValue={globalFilter}
          onSubmit={(searchValues) =>
            setGlobalFilter({
              ...globalFilter,
              [filterKey]: { ...globalFilter?.[filterKey], ...searchValues },
            })
          }
          onClear={(searchValues) =>
            setGlobalFilter({
              ...globalFilter,
              [filterKey]: { ...globalFilter?.[filterKey], ...searchValues },
            })
          }
        />
      </div>
    </>
  );
}
